import React from "react";

/**
 * A custom grey box component that displays the depot name and an optional plus sign and home depot icon.
 * @param {Object} props - The props object containing the following properties:
 *   - depotname: The name of the depot to display.
 *   - title: The title attribute for the span element.
 *   - plusShow: A boolean indicating whether to display a plus sign.
 *   - homeDepotIcon: A boolean indicating whether to display a home depot icon.
 * @returns The rendered grey box component.
 */
const CustomeDepotGreyBox = (props) => {
  const { depotname, title, plusShow, homeDepotIcon, className } = props;
  return (
    <>
      <span title={title} className={"greyBox " + className}>{plusShow && '+'}{depotname}{homeDepotIcon && <i className="mdi mdi-home-outline"></i>}</span>
    </>
  );
};

export default CustomeDepotGreyBox;
